import { Injectable } from "@angular/core";
import { HUBPermission } from "@data/security";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";
import { Observable } from "rxjs";

const API_URL = API.API_URL;

@Injectable({
	providedIn: "root"
})
export class SecurityPermissionsService {
	private _securityAPIBase = `${API_URL}/security`;
	private _permissionsBase = `${this._securityAPIBase}/permissions`;

	constructor(private httpManager: HttpManager) {}

	getPermissions(id: number = null): Observable<any> {
		if (id) {
			return this.httpManager.httpGet<any>(`${this._permissionsBase}/${id}`, { id: id });
		}
		return this.httpManager.httpGet<any>(`${this._permissionsBase}`);
	}

	addPermissions(body: HUBPermission): Observable<any> {
		return this.httpManager.httpPost<any>(`${this._permissionsBase}/add`, body);
	}

	updatePermissions(body: HUBPermission): Observable<any> {
		return this.httpManager.httpPost<any>(`${this._permissionsBase}/${body.PermissionID}/update`, body);
	}

	deletePermission(id: number): Observable<any> {
		return this.httpManager.httpGet<any>(`${this._permissionsBase}/${id}/delete`);
	}
}
